function ContactUs() {
  return <h1>Contact Us Page</h1>;
}

export default ContactUs;